export const USER_PAGE_ACTIONS = {
  FETCH_ONE_USER: 'USER_PAGE_ACTIONS/FETCH_ONE_USER',
  SET_ONE_USER: 'USER_PAGE_ACTIONS/SET_ONE_USER',
  SET_LOADING_STATUS: 'USER_PAGE_ACTIONS/SET_LOADING_STATUS',
  SHOW_ERROR: 'USER_PAGE_ACTIONS/SHOW_ERROR',

  FETCH_USER_PAGE_MENTORS: 'USER_PAGE_ACTIONS/FETCH_USER_PAGE_MENTORS',
  SET_USER_PAGE_MENTORS: 'USER_PAGE_ACTIONS/SET_USER_PAGE_MENTORS',
  SET_USER_PAGE_BUSINESS_UNITS: 'USER_PAGE_ACTIONS/SET_USER_PAGE_BUSINESS_UNITS',
  ATTACH_USER_PAGE_MENTORS_BULK: 'USER_PAGE_ACTIONS/ATTACH_USER_PAGE_MENTORS_BULK',
  ATTACH_USER_PAGE_COURSE: 'USER_PAGE_ACTIONS/ATTACH_USER_PAGE_COURSE',
  CHANGE_USER_BUSINESS_UNITS: 'USER_PAGE_ACTIONS/CHANGE_USER_BUSINESS_UNITS',
  CHANGE_USER_STATUS: 'USER_PAGE_ACTIONS/CHANGE_USER_STATUS',
  CHANGE_USER_LOCALE: 'USER_PAGE_ACTIONS/CHANGE_USER_LOCALE',

  FETCH_USER_PERSONAL_PROGRAM: 'USER_PAGE_ACTIONS/FETCH_USER_PERSONAL_PROGRAM',
  MOVE_USER_TO_COURSE_LEVEL: 'USER_PAGE_ACTIONS/MOVE_USER_TO_COURSE_LEVEL',
  SET_USER_COURSE_LOCATION_FLAG: 'USER_PAGE_ACTIONS/SET_USER_COURSE_LOCATION_FLAG',
  CLEAR_USER_COURSE_LOCATION_FLAG: 'USER_PAGE_ACTIONS/CLEAR_USER_COURSE_LOCATION_FLAG',

  SHOW_TOAST: 'USER_PAGE_ACTIONS/SHOW_TOAST',
  RESET_USER_PASSWORD: 'USER_PAGE_ACTIONS/RESET_USER_PASSWORD',
  UPDATE_USER_PHONE: 'USER_PAGE_ACTIONS/UPDATE_USER_PHONE',
  UPDATE_USER_NAME: 'USER_PAGE_ACTIONS/UPDATE_USER_NAME',
  UPDATE_USER_BIRTHDATE: 'USER_PAGE_ACTIONS/UPDATE_USER_BIRTHDATE',
  SET_PHONE_UPDATE_LOADING: 'USER_PAGE_ACTIONS/SET_PHONE_UPDATE_LOADING',
  FINISH_PHONE_UPDATE: 'USER_PAGE_ACTIONS/FINISH_PHONE_UPDATE',
  UPDATE_USER_MFA: 'USER_PAGE_ACTIONS/UPDATE_USER_MFA',
  CHANGE_USER_EXPERIMENTAL_FEATURES: 'USER_PAGE_ACTIONS/CHANGE_USER_EXPERIMENTAL_FEATURES',
};

export const putUserPageLoadingStatus = (status) => ({
  type: USER_PAGE_ACTIONS.SET_LOADING_STATUS,
  payload: status,
});

export const showUserPageError = () => ({
  type: USER_PAGE_ACTIONS.SHOW_ERROR,
});

export const fetchUserPage = (id) => ({
  type: USER_PAGE_ACTIONS.FETCH_ONE_USER,
  payload: id,
});

export const putUserPage = (user) => ({
  type: USER_PAGE_ACTIONS.SET_ONE_USER,
  payload: user,
});

export const putUserPageMentors = (mentors) => ({
  type: USER_PAGE_ACTIONS.SET_USER_PAGE_MENTORS,
  payload: mentors,
});

export const putUserPageBusinessUnits = (businessUnits) => ({
  type: USER_PAGE_ACTIONS.SET_USER_PAGE_BUSINESS_UNITS,
  payload: businessUnits,
});

export const attachUserPageMentorsBulk = (userId, changes) => ({
  type: USER_PAGE_ACTIONS.ATTACH_USER_PAGE_MENTORS_BULK,
  payload: { userId, changes },
});

export const attachUserPageCourse = (courseId, userId) => ({
  type: USER_PAGE_ACTIONS.ATTACH_USER_PAGE_COURSE,
  payload: { courseId, userId },
});

export const changeUserBusinessUnits = (businessUnits, userId) => ({
  type: USER_PAGE_ACTIONS.CHANGE_USER_BUSINESS_UNITS,
  payload: { businessUnits, userId },
});

export const moveUserToCourseLevel = (payload) => ({
  type: USER_PAGE_ACTIONS.MOVE_USER_TO_COURSE_LEVEL,
  payload,
});

export const showToast = (toastType) => ({
  type: USER_PAGE_ACTIONS.SHOW_TOAST,
  payload: toastType,
});

export const changeUserStatus = (status, userId) => ({
  type: USER_PAGE_ACTIONS.CHANGE_USER_STATUS,
  payload: { status, userId },
});

export const changeUserLocale = (locale, userId) => ({
  type: USER_PAGE_ACTIONS.CHANGE_USER_LOCALE,
  payload: { locale, userId },
});

export const fetchMentors = () => ({
  type: USER_PAGE_ACTIONS.FETCH_USER_PAGE_MENTORS,
});

export const fetchUserPersonalProgram = (userId) => ({
  type: USER_PAGE_ACTIONS.FETCH_USER_PERSONAL_PROGRAM,
  payload: userId,
});

export const resetUserPassword = (userId) => ({
  type: USER_PAGE_ACTIONS.RESET_USER_PASSWORD,
  payload: { userId },
});

export const updateUserPhone = (userId, phoneNumber) => ({
  type: USER_PAGE_ACTIONS.UPDATE_USER_PHONE,
  payload: { userId, phoneNumber },
});

export const setPhoneUpdateLoading = (status) => ({
  type: USER_PAGE_ACTIONS.SET_PHONE_UPDATE_LOADING,
  payload: status,
});

export const finishPhoneUpdate = (phone) => ({
  type: USER_PAGE_ACTIONS.FINISH_PHONE_UPDATE,
  payload: phone,
});

export const updateUserMfa = (userId, method) => ({
  type: USER_PAGE_ACTIONS.UPDATE_USER_MFA,
  payload: { userId, method },
});

export const setUserCourseLocationFlag = (payload) => ({
  type: USER_PAGE_ACTIONS.SET_USER_COURSE_LOCATION_FLAG,
  payload,
});

export const clearUserCourseLocationFlag = (userId) => ({
  type: USER_PAGE_ACTIONS.CLEAR_USER_COURSE_LOCATION_FLAG,
  payload: { userId },
});

export const changeUserExperimentalFeatures = (experimentalFeatures, userId) => ({
  type: USER_PAGE_ACTIONS.CHANGE_USER_EXPERIMENTAL_FEATURES,
  payload: { experimentalFeatures, userId },
});

export const updateUserName = (userId, firstName, lastName) => ({
  type: USER_PAGE_ACTIONS.UPDATE_USER_NAME,
  payload: { userId, firstName, lastName },
});

export const updateUserBirthdate = (userId, birthdate) => ({
  type: USER_PAGE_ACTIONS.UPDATE_USER_BIRTHDATE,
  payload: { userId, birthdate },
});